import {
  PrimaryTextColor,
  boldFont,
  centerItemFlex,
  getRelativeFontSize,
  mediumFont,
  normalFont,
  primaryBlueColor,
  regularFont,
} from "../../../../utils/styles";
import BackgroundImg from "../../../../assets/images/bg-pattern-1.svg";

const PasswordResetLinkStyles = {
  mainContentWrapper: {
    backgroundImage: `url(${BackgroundImg})`,
    backgroundRepeat: " no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: "100vh",
    width: "100%",
  },
  contentWrapper: {
    width: "100%",
    height: "100vh",
    ...centerItemFlex,
    flexDirection: "column",
    gap: 2,
  },
  cardHeader: {
    padding: "74px 23px 0px 23px",
  },
  cardTitle: {
    fontSize: getRelativeFontSize(10),
    ...boldFont,
    color: PrimaryTextColor,
  },
  cardSubText: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
    color: PrimaryTextColor,
  },
  cardContent: {
    padding: "0px 24px",
    marginTop: "46px",
    marginBottom: 4,
  },
  cardInfo: {
    color: "#646DEA",
    ...regularFont,
    fontSize: "14px",
  },
  cardFooter: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: 3,
  },
  signUpStyle: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },
  backToLogin: {
    color: primaryBlueColor,
    cursor: "pointer",
    ...mediumFont,
    fontSize: "16px",
    marginLeft: "13px",
  },
  disclamer: {
    color: "#9E9FAB",
    ...regularFont,
    fontSize: "14px",
  },
};

export default PasswordResetLinkStyles;
